import { get, post } from "../xhr";


export function getUsers(page = 1, type = 'basix') {
    return get(`users/list/${type}/?page=${page}`, 'application/json')
}

export function getUserData(userId) {
    return get(`users/get-profile/${userId}`, 'application/json')
}

export function getNotifications(page = 1) {
    return get(`users/notifications/?page=${page}`, 'application/json')
}

export function updatePrivilege(userId) {
    return post(`users/update-privilege/${userId}`, 'application/json', {})
}